module.exports = "https://s91588.cdn.ngenix.net/creditselection-frontend/_next/static/images/card1-93aead454daf556cb2ed47dc014621d9.png";